
import { defineComponent, computed } from 'vue'
import { RESOLUTIONS } from '@/components/common/ResolutionSelector.vue'

const PREV_LABELS = {
  [RESOLUTIONS.RUISEKI]: '前月',
  [RESOLUTIONS.WEATHER]: '前日',
  [RESOLUTIONS.MINUTE]: '5分前',
  [RESOLUTIONS.HOUR]: '前日',
  [RESOLUTIONS.DAY]: '前日',
  [RESOLUTIONS.MONTH]: '前月',
  [RESOLUTIONS.YEAR]: '前年',
  [RESOLUTIONS.TEN_MIN]: '2時間前',
  [RESOLUTIONS.HALF_DAY]: '12時間前',
  [RESOLUTIONS.CAMERA_MIN]: '5分前',
  [RESOLUTIONS.CAMERA_HOUR]: '1時間前',
}

const NEXT_LABELS = {
  [RESOLUTIONS.RUISEKI]: '翌月',
  [RESOLUTIONS.WEATHER]: '翌日',
  [RESOLUTIONS.MINUTE]: '5分後',
  [RESOLUTIONS.HOUR]: '翌日',
  [RESOLUTIONS.DAY]: '翌日',
  [RESOLUTIONS.YEAR]: '翌年',
  [RESOLUTIONS.MONTH]: '翌月',
  [RESOLUTIONS.TEN_MIN]: '2時間後',
  [RESOLUTIONS.HALF_DAY]: '12時間後',
  [RESOLUTIONS.CAMERA_MIN]: '5分後',
  [RESOLUTIONS.CAMERA_HOUR]: '1時間後',
}

const TODAY_LABELS = {
  [RESOLUTIONS.RUISEKI]: '今月',
  [RESOLUTIONS.WEATHER]: '今日',
  [RESOLUTIONS.MINUTE]: '現在',
  [RESOLUTIONS.HOUR]: '現在',
  [RESOLUTIONS.DAY]: '今日',
  [RESOLUTIONS.MONTH]: '今月',
  [RESOLUTIONS.YEAR]: '今年',
  [RESOLUTIONS.TEN_MIN]: '現在時刻',
  [RESOLUTIONS.HALF_DAY]: '現在時刻',
  [RESOLUTIONS.CAMERA_MIN]: '現在時刻',
  [RESOLUTIONS.CAMERA_HOUR]: '現在時刻',
}

export default defineComponent({
  props: {
    resolution: {
      type: String,
      default: RESOLUTIONS.HOUR,
    },
  },
  setup(props, { emit }) {
    const prevLabel = computed(() => PREV_LABELS[props.resolution])
    const todayLabel = computed(() => TODAY_LABELS[props.resolution])
    const nextLabel = computed(() => NEXT_LABELS[props.resolution])

    const move = (tag: string) => {
      emit(tag)
    }

    return {
      prevLabel,
      todayLabel,
      nextLabel,
      move,
    }
  },
})
